module.exports = __webpack_public_path__ + "71272edcdb472439cdabbc49123b19eb.png";